// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submissions-files {
  margin-top: 24px;
}
.submissions-files__list {
  border-top: 1px solid var(--divider, #eaecf0);
  border-bottom: 1px solid var(--divider, #eaecf0);
}
.submissions-files__list .file {
  display: flex;
  gap: 16px;
  padding: 6px 24px;
  align-items: center;
  justify-content: space-between;
}
.submissions-files__list .file:hover {
  background-color: var(--Primary-50, #f9f5ff);
}
.submissions-files__list .file:hover .file__actions {
  visibility: visible;
}
.submissions-files__list .file:nth-child(n+2) {
  border-top: 1px solid var(--divider, #eaecf0);
}
.submissions-files__list .file__name {
  display: inline-flex;
  min-width: 30%;
  max-width: 30%;
  word-break: break-word;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--Secondary-eading, #101828);
  cursor: pointer;
}
.submissions-files__list .file__date {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.01em;
  text-align: left;
  color: var(--Secondary-Text, #667085);
}
.submissions-files__list .file__actions {
  min-width: 56px;
  display: inline-flex;
  gap: 16px;
  visibility: hidden;
  align-items: center;
}
.submissions-files__list .file__actions button {
  width: 20px;
  height: 20px;
  display: inline-flex;
  padding: 0;
  outline: none;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  cursor: pointer;
}
.submissions-files__list .file__actions button svg {
  width: 100%;
  height: 100%;
}

.mobile .submissions-files__list .file {
  padding: 6px 6px;
  gap: 12px;
}
.mobile .submissions-files__list .file .file__name {
  min-width: unset;
  max-width: unset;
  width: unset;
  flex-grow: 1;
}
.mobile .submissions-files__list .file .file__date {
  white-space: nowrap;
  width: 80px;
  max-width: 80px;
  min-width: 80px;
}
.mobile .submissions-files__list .file .file__actions {
  width: 50px;
  min-width: 50px;
  max-width: 50px;
}`, "",{"version":3,"sources":["webpack://./src/pages/corporate-library/files/layouts/submissions/styles.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,6CAAA;EACA,gDAAA;AACJ;AACI;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;AACN;AACM;EACE,4CAAA;AACR;AACQ;EACE,mBAAA;AACV;AAGM;EACE,6CAAA;AADR;AAIM;EACE,oBAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uCAAA;EACA,eAAA;AAFR;AAKM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qCAAA;AAHR;AAMM;EACE,eAAA;EACA,oBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AAJR;AAMQ;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,eAAA;AAJV;AAMU;EACE,WAAA;EACA,YAAA;AAJZ;;AAcI;EACE,gBAAA;EACA,SAAA;AAXN;AAaM;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;AAXR;AAcM;EACE,mBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAZR;AAeM;EACE,WAAA;EACA,eAAA;EACA,eAAA;AAbR","sourcesContent":[".submissions-files {\n  margin-top: 24px;\n\n  &__list {\n    border-top: 1px solid var(--divider, #eaecf0);\n    border-bottom: 1px solid var(--divider, #eaecf0);\n\n    .file {\n      display: flex;\n      gap: 16px;\n      padding: 6px 24px;\n      align-items: center;\n      justify-content: space-between;\n\n      &:hover {\n        background-color: var(--Primary-50, #f9f5ff);\n\n        .file__actions {\n          visibility: visible;\n        }\n      }\n\n      &:nth-child(n + 2) {\n        border-top: 1px solid var(--divider, #eaecf0);\n      }\n\n      &__name {\n        display: inline-flex;\n        min-width: 30%;\n        max-width: 30%;\n        word-break: break-word;\n        align-items: center;\n        gap: 12px;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 20px;\n        color: var(--Secondary-eading, #101828);\n        cursor: pointer;\n      }\n\n      &__date {\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 21px;\n        letter-spacing: -0.01em;\n        text-align: left;\n        color: var(--Secondary-Text, #667085);\n      }\n\n      &__actions {\n        min-width: 56px;\n        display: inline-flex;\n        gap: 16px;\n        visibility: hidden;\n        align-items: center;\n\n        button {\n          width: 20px;\n          height: 20px;\n          display: inline-flex;\n          padding: 0;\n          outline: none;\n          border: 0;\n          align-items: center;\n          justify-content: center;\n          background-color: transparent;\n          cursor: pointer;\n\n          svg {\n            width: 100%;\n            height: 100%;\n          }\n        }\n      }\n    }\n  }\n}\n\n.mobile {\n  .submissions-files__list {\n    .file {\n      padding: 6px 6px;\n      gap: 12px;\n\n      .file__name {\n        min-width: unset;\n        max-width: unset;\n        width: unset;\n        flex-grow: 1;\n      }\n\n      .file__date {\n        white-space: nowrap;\n        width: 80px;\n        max-width: 80px;\n        min-width: 80px;\n      }\n\n      .file__actions {\n        width: 50px;\n        min-width: 50px;\n        max-width: 50px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
